/**
 * EDC REST API
 * EDC REST APIs - merged by OpenApiMerger
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Injectable } from '@angular/core';
import { HttpResponse, HttpEvent, HttpContext } from '@angular/common/http';
import { Observable, from } from 'rxjs';

import { EdcConnectorClient } from '@think-it-labs/edc-connector-client';
import { ContractAgreement, QuerySpec } from '../model'
import {ContractAgreementController} from "../../mgmt-api-client";
import {AppConfigService, AppConfig} from "../../app/app-config.service";

@Injectable({
  providedIn: 'root'
})
export class ContractAgreementService {

    config?: AppConfig;
    apiKey = "";
    private contractAgreements: ContractAgreementController;
    // private contractAgreements = this.edcConnectorClient.management.contractAgreements;

    constructor(private edcConnectorClient: EdcConnectorClient, private configService: AppConfigService) {
      this.config = this.configService.getConfig();
      this.apiKey = this.config?.apiKey || '';
      this.contractAgreements = new ContractAgreementController(this.edcConnectorClient.createContext(this.apiKey, this.edcConnectorClient.addresses));
    }

    /**
     * Gets all contract agreements according to a particular query
     * @param querySpec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public queryAllAgreements(querySpec?: QuerySpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<ContractAgreement>>;
    public queryAllAgreements(querySpec?: QuerySpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<ContractAgreement>>>;
    public queryAllAgreements(querySpec?: QuerySpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<ContractAgreement>>>;
    public queryAllAgreements(querySpec?: QuerySpec): Observable<any> {
        return from(this.contractAgreements.queryAll(querySpec))
    }

    // Added By Nri On 2025.4.24 Start
    /**
     * Gets Negotiation by agreementId
     * @param agreementId
     */
    public getNegotiation(agreementId: string): Observable<any> {
      return from(this.contractAgreements.getNegotiation(agreementId))
    }
    // Added By Nri On 2025.4.24 End

}
